import { Pagination } from "@mui/material";
import {
  CalendarIcon,
  PersonIcon,
  SewingPinFilledIcon,
} from "@radix-ui/react-icons";
import { useEffect, useState } from "react";
import ReactDatePicker from "react-datepicker";
import { checkTagValidity, months, years } from "../../Utils/Utils";
import { LIST_IDENTIFICATION } from "../../Utils/constant";
import { Abonnement } from "../../components/Abonnement/Abonnement";
import { ContentLoading } from "../../components/Widget/ContentLoading";
import { Pbo } from "../../components/Widget/Pbo";
import { Tabs } from "../../components/Widget/Tab";
import { useStoreLivraison } from "../../store/livraisonStore";

const Identification = () => {
  const [page, setPage] = useState(0);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [select, setSelect] = useState("ANNEE");
  const [active, setActive] = useState({
    index: 0,
    value: "En attente d'identification",
  });

  const listeTabsData = [
    {
      index: 0,
      value: "En attente d'identification",
      tag: "LISTE_EN_ATTENTE_IDENTIFICATION",
    },
    {
      index: 1,
      value: "Identifié",
      tag: "LISTE_IDENTIFIER",
    },
  ];

  const filteredTabsData = listeTabsData
    .filter((tab) => checkTagValidity(tab.tag))
    .map((tab, index) => ({ ...tab, index }));

  useEffect(() => {
    if (filteredTabsData.length !== 0) {
      setActive(filteredTabsData[0]);
    }
  }, []);

  const more = (page) => {
    setPage(page - 1);
    store.getData(
      LIST_IDENTIFICATION,
      { page: page - 1, param: "", size: 10 },
      "&periode=&mois=&annee=&dateDebut=&dateFin=&inTime="
    );
  };

  const store = useStoreLivraison();
  useEffect(() => {
    store.getData(
      LIST_IDENTIFICATION,
      { page: 0, param: "", size: 10 },
      "&periode=&mois=&annee=&dateDebut=&dateFin=&inTime="
    );
  }, []);

  return (
    <div className="">
      <div className="lg:flex gap-8 items-center ">
        <h3 class="text-3xl font-bold font-mtn">Identification</h3>
        <div className="ml-auto lg:flex gap-x-3">
          <select
            onChange={(e) => {
              setSelect(e.target.value);
            }}
            className="my-2 select"
          >
            <option>Periode</option>
            <option value="MOIS">Filtre par mois</option>
            <option value="ANNEE" selected>
              Filtre par années
            </option>
          </select>
          {select === "MOIS" ? (
            <select onChange={(e) => {}} className="my-2 select">
              <option disabled selected>
                mois
              </option>
              {months.map((item) => (
                <option value={item.code}>{item.name}</option>
              ))}
            </select>
          ) : select === "ANNEE" ? (
            <select onChange={(e) => {}} className="my-2 select ">
              <option disabled selected>
                années
              </option>
              {years.map((item) => (
                <option
                  value={item.name}
                  selected={
                    new Date().getFullYear() === Number(item.name)
                      ? true
                      : false
                  }
                >
                  {item.name}
                </option>
              ))}
            </select>
          ) : (
            <ReactDatePicker
              dateFormat="dd-MM-yyyy"
              selected={startDate}
              onChange={(update) => {
                if (update[1] != null) {
                }
                setDateRange(update);
              }}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              className="text-xs font-normal cursor-pointer btn btn-sm hover:bg-gray-100 text-center h-8 my-2 w-52 rounded-md border border-input bg-gray-100 px-3 py-1 shadow-sm"
            />
          )}
        </div>
      </div>
      <div className="bg-white rounded-md px-2 py-4 mt-3">
        {/* <div className="mt-3 flex gap-1">
          <input
            type="text"
            onChange={() => {

            }}
            placeholder="Rechercher element..."
            className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
          />
        </div> */}

        {filteredTabsData.length !== 0 ? (
          <Tabs
            tabsData={filteredTabsData}
            active={active}
            setActive={setActive}
          />
        ) : null}

        {active.index === 0 ? (
          <Abonnement
            status={"EN_ATTENTE_DE_IDENTIFICATION"}
            step={4}
            perm={"POURSUIVRE_IDENTIFICATION"}
          />
        ) : active.index === 1 ? (
          <>
            <div>
              <div className="flex items-center gap-2">
                <input
                  onChange={(e) =>
                    store.getData(
                      LIST_IDENTIFICATION,
                      { page: 0, param: `${e.target.value}`, size: 10 },
                      `&periode=&mois=&annee=&dateDebut=&dateFin=&inTime=`
                    )
                  }
                  type="text"
                  placeholder="Rechercher element..."
                  className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
                />
                <select
                  onChange={(e) =>
                    store.getData(
                      LIST_IDENTIFICATION,
                      { page: 0, param: "", size: 10 },
                      `&periode=&mois=&annee=&dateDebut=&dateFin=&inTime=${e.target.value}`
                    )
                  }
                  className="select pl-non my-3"
                >
                  <option disabled selected>
                    Delais de traitement
                  </option>
                  <option value="">Tout afficher</option>
                  <option value={"true"}>Intention dans le delais</option>
                  <option value={"false"}>Intention hors delais</option>
                </select>
              </div>

              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-2 my-4">
                {store?.data?.data?.length === 0 ? (
                  <div className="flex justify-center items-center">
                    <img src="" alt="" srcset="" />
                  </div>
                ) : store?.data?.data?.length !== 0 && !store?.loading ? (
                  store?.data?.data?.map((item) => (
                    <div
                      className={`${
                        !item?.inTime
                          ? "border-red-300 border-2 border-dashed"
                          : "border-slate-200 border"
                      } relative bg-white rounded-xl  shadow-sm`}
                    >
                      <dialog
                        id={`show${item.id}`}
                        className="modal bg-slate-900/70"
                      >
                        <div className="modal-box w-11/12 max-w-2xl">
                          <div className="flex items-center justify-between p-3">
                            <div className="flex flex-row gap-2">
                              <h2 className="font-semibold flex flex-row items-center text-md">
                                Details d'identification
                              </h2>
                            </div>
                            <form method="dialog">
                              <button
                                id="fermer_create_trajet"
                                className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                              >
                                ✕
                              </button>
                            </form>
                          </div>
                          <div className="">
                            <div className="bg-white p-3 rounded-lg border">
                              <div className="mt-6 border-t border-gray-100">
                                <dl className="divide-y divide-gray-100">
                                  <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                    <dt className="text-sm font-bold leading-6 text-gray-900">
                                      Nom et prenom du client
                                    </dt>
                                    <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                      {item?.nomPrenoms ?? "--"}
                                    </dd>
                                  </div>

                                  <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                    <dt className="text-sm font-bold leading-6 text-gray-900">
                                      Email
                                    </dt>
                                    <dd className="mt-1 text-sm font-medium leading-6 text-gray-900 sm:col-span-2 sm:mt-0">
                                      {item?.abonnement?.client?.email ?? "--"}
                                    </dd>
                                  </div>
                                  <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                    <dt className="text-sm font-bold leading-6 text-gray-900">
                                      Contact client
                                    </dt>
                                    <dd className="mt-1 text-sm font-medium leading-6 text-gray-900 sm:col-span-2 sm:mt-0">
                                      {item?.abonnement?.client?.numero ?? "--"}
                                    </dd>
                                  </div>
                                  <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                    <dt className="text-sm font-bold leading-6 text-gray-900">
                                      Ville du client
                                    </dt>
                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                      {item?.abonnement?.commune ?? "--"}
                                    </dd>
                                  </div>
                                  <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                    <dt className="text-sm font-bold leading-6 text-gray-900">
                                      Date et heure d'identification
                                    </dt>
                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                      {item?.dateHIdentification
                                        ? new Date(
                                            item?.dateHIdentification
                                          ).toLocaleString()
                                        : "--"}
                                    </dd>
                                  </div>

                                  <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                    <dt className="text-sm font-bold leading-6 text-gray-900">
                                      Date et heure d'approbation
                                    </dt>
                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                      {item?.dateHApprobation
                                        ? new Date(
                                            item?.dateHIdentification
                                          ).toLocaleString()
                                        : "--"}
                                    </dd>
                                  </div>

                                  <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                    <dt className="text-sm font-bold leading-6 text-gray-900">
                                      Date et heure d'activation
                                    </dt>
                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                      {item?.dateHActivation
                                        ? new Date(
                                            item?.dateHActivation
                                          ).toLocaleString()
                                        : "--"}
                                    </dd>
                                  </div>

                                  <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                    <dt className="text-sm font-bold leading-6 text-gray-900">
                                      Status d'approbation
                                    </dt>
                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                      {item?.approvalStatus}
                                    </dd>
                                  </div>

                                  <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                    <dt className="text-sm font-bold leading-6 text-gray-900">
                                      Status d'activation
                                    </dt>
                                    <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                      {item?.registrationStatus}
                                    </dd>
                                  </div>
                                </dl>
                              </div>
                            </div>
                          </div>
                        </div>
                      </dialog>
                      <div className="rounded-t-xl flex items-center gap-3 border-b-[2px] border-orange-100 px-2 py-3">
                        <p className="text-[12px] font-semibold">
                          {item?.abonnement?.eligibilite?.numeroTicket}
                        </p>
                        <p className="text-red-500 text-xs">
                          {!item?.inTime ? "Hors delais" : ""}
                        </p>
                      </div>
                      <div className="px-3 py-2">
                        <div className="my-1 flex items-center">
                          <div className="flex items-center gap-2">
                            <Pbo
                              pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                              port={item?.brin}
                            />
                          </div>
                        </div>

                        <div className="flex gap-1 ">
                          <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                          <div>
                            <p className="text-[13px] font-medium">
                              {item?.abonnement.client?.nomPrenoms}
                            </p>
                            <p className="text-xs flex font-semibold gap-2">
                              <span>{item?.abonnement.client?.numero}</span>{" "}
                              {" | "}{" "}
                              <span>{item?.abonnement.client?.email}</span>{" "}
                            </p>
                          </div>
                        </div>

                        <h1 className="text-xs flex gap-1 items-center my-2">
                          Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                          {item?.abonnement?.forfait?.categorie
                            ?.replace("_", "")
                            .toLowerCase()}
                        </h1>

                        <div className=" gap-1">
                          <div>
                            {item?.abonnement?.numeroFtth && (
                              <p className="text-[13px] font-medium">
                                Numero FTTH : {item?.abonnement?.numeroFtth}
                              </p>
                            )}

                            {item?.PIID && (
                              <p className="text-[13px] font-medium">
                                PID: PI{item?.PIID}
                              </p>
                            )}

                            {item?.abonnement?.numeroSerie && (
                              <p className="text-xs flex font-semibold gap-2">
                                SN :{" "}
                                <span>{item?.abonnement?.numeroSerie}</span>
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="items-center gap-2 space-y-3">
                          <h1 className="text-[14px] font-bold flex items-center">
                            <SewingPinFilledIcon />
                            {item?.abonnement?.commune +
                              ", " +
                              item?.abonnement?.quartier}
                          </h1>
                          <div className="pb-3 border-b flex gap-4 items-center">
                            <p className="text-xs flex gap-1 items-center font-medium">
                              <CalendarIcon /> Date identification :
                              {" " + item?.dateCreation
                                ? new Date(item?.dateCreation).toLocaleString()
                                : "--"}
                            </p>
                          </div>

                          <button
                            onClick={() => {
                              document
                                .getElementById(`show${item.id}`)
                                .showModal();
                            }}
                            className="btn btn-sm bg-main text-xs"
                          >
                            Voir l'identification
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <ContentLoading />
                )}
              </div>
            </div>
            <div className="my-3 flex justify-end">
              <Pagination
                onChange={(event, newValue) => more(newValue)}
                onSelect={(selectedPage) => more(selectedPage)}
                count={store?.data?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Identification;
